import { useState } from 'react';
import {
  FaTimes,
  FaUser,
  FaClipboardList,
  FaExchangeAlt,
  FaDesktop,
  FaCopy,
  FaCheck,
} from 'react-icons/fa';
import styles from "../../styles/styles.module.css"
import {ENUM_STATUS } from '../../interfaces/audits.interface';

function AuditModal({ model, onClose }) {
  const [copied, setCopied] = useState(false);
  const date =new Date(model.createdAt).toLocaleDateString('es-MX')
  const time=new Date(model.createdAt).toLocaleTimeString('es-MX')
  const handleCopy = () => {
    const text = `ID: ${model.id} | Fecha: ${date} ${time} | Módulo: ${model.module} | Acción: ${model.action} | Estado: ${model.status} | Usuario: ${model.username} (${model.role}) | IP: ${model.ipAddress} | SO: ${model.os} | Navegador: ${model.browser}`;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };
  
const badgeClass = {
  Alta: styles.badgeCreate,
  Edición: styles.badgeEdit,
  Eliminación: styles.badgeDelete,
  Consulta: styles.badgeQuery,
  'Inicio de Sesión': styles.badgeSession,
};

return (
  <div
    className={`modal-overlay ${styles.modalOverlayAuditoria}`}
    onClick={onClose}
  >
    <div
      className={`modal-content ${styles.modalContentAuditoria}`}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header global reutilizado */}
      <div className="modal-header">
        <div>
          <h2 className="modal-title">
            Detalle del Evento {model.id ? `#${model.id}` : ''}
          </h2>
          <span className={styles.modalSubtitle}>
            Información completa de la auditoría
          </span>
        </div>
        <button
          type="button"
          className="modal-close-btn"
          onClick={onClose}
          title="Cerrar"
          aria-label="Cerrar modal"
        >
          <FaTimes />
        </button>
      </div>
      {/* Body global reutilizado */}
      <div className={`modal-body ${styles.modalBodyAuditoria}`}>
        <div className={styles.detailsGrid}>
          {/* Información general */}
          <div className={styles.infoCard}>
            <h3 className={styles.sectionTitle}>
              <FaClipboardList />
              Información General
            </h3>

            <div className={styles.fieldsContainer}>
              <div className={styles.field}>
                <span className={styles.label}>Fecha de la acción</span>
                <strong className={styles.value}>
                  <p>{date}</p>
                </strong>
              </div>

              <div className={styles.field}>
                <span className={styles.label}>Hora</span>
                <strong className={styles.value}>{time}</strong>
              </div>

              <div className={styles.field}>
                <span className={styles.label}>Módulo</span>
                <strong className={styles.value}>{model.module}</strong>
              </div>

              <div className={styles.field}>
                <span className={styles.label}>Acción</span>

                <div className={styles.badgeContainer}>
                  <span
                    className={
                      badgeClass[model.action] || styles.badgeQuery
                    }
                  >
                    {model.action}
                  </span>
                </div>
              </div>

              <div className={styles.fieldLast}>
                <span className={styles.label}>Estado</span>

                <div className={styles.badgeContainer}>
                  <span
                    className={`${styles.badgeStatus} ${
                      model.status ? styles.statusOk : styles.statusFail
                    }`}
                  >
                    {ENUM_STATUS[model.status]}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Usuario */}
          <div className={styles.infoCard}>
            <h3 className={styles.sectionTitle}>
              <FaUser />
              Usuario
            </h3>

            <div className={styles.fieldsContainer}>
              <div className={styles.field}>
                <span className={styles.label}>Nombre</span>
                <strong className={styles.value}>
                  {model.username}
                </strong>
              </div>

              <div className={styles.fieldLast}>
                <span className={styles.label}>Rol</span>
                <strong className={styles.value}>{model.role}</strong>
              </div>
            </div>
          </div>

          {/* Entorno de acceso */}
          <div className={styles.infoCard}>
            <h3 className={styles.sectionTitle}>
              <FaDesktop />
              Entorno de Acceso
            </h3>

            <div className={styles.fieldsContainer}>
              <div className={styles.field}>
                <span className={styles.label}>Dispositivo</span>
                <strong className={styles.value}>{model.os}</strong>
              </div>

              <div className={styles.field}>
                <span className={styles.label}>Agente</span>
                <strong className={styles.value}>{model.browser}</strong>
              </div>

              <div className={styles.fieldLast}>
                <span className={styles.label}>Dirección IP</span>
                <strong
                  className={`${styles.value} ${styles.monospace}`}
                >
                  {model.ipAddress}
                </strong>
              </div>
            </div>
          </div>

          {/* Trazabilidad */}
          <div className={styles.traceabilityCard}>
            <h3 className={styles.sectionTitle}>
              <FaExchangeAlt />
              Trazabilidad del Evento
            </h3>

            <div className={styles.traceability}>
              <div className={styles.traceabilityLine} />

              {model.traceability && model.traceability.length > 0 ? (
                model.traceability.map((t, i) => (
                  <div key={i} className={styles.traceabilityItem}>
                    <div className={styles.traceabilityDot} />

                    <div className={styles.traceabilityContent}>
                      <span className={styles.traceabilityEvent}>
                        {t.evento || `Paso ${i + 1}`}
                      </span>

                      <span className={styles.traceabilityDetail}>
                        {t.detalle ||
                          (typeof t === 'string'
                            ? t
                            : JSON.stringify(t))}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <div className={styles.emptyTraceability}>
                  No hay pasos de trazabilidad detallados para este
                  registro.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className={styles.modalFooter}>
        <button
          type="button"
          onClick={handleCopy}
          className={styles.cancelButton}
        >
          {copied ? (
            <FaCheck className={styles.copySuccessIcon} />
          ) : (
            <FaCopy />
          )}

          {copied ? 'Copiado' : 'Copiar Resumen'}
        </button>

        <button
          type="button"
          onClick={onClose}
          className={styles.cancelButton}
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
);

}

export default AuditModal;
